import { render } from "./TeamImage.vue?vue&type=template&id=0b0864f8&scoped=true"
import script from "./TeamImage.vue?vue&type=script&lang=js"
export * from "./TeamImage.vue?vue&type=script&lang=js"

import "./TeamImage.vue?vue&type=style&index=0&id=0b0864f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0864f8"]])

export default __exports__